export default class ClickableRowVariant {
  get(row) {
    return 'clickable'
  }
}
